// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-components-AiResearch-References-Graph-style__container--OBMga{width:182px;border:solid 1px #747576;border-radius:3px;cursor:pointer}", "",{"version":3,"sources":["webpack://./src/components/AiResearch/References/Graph/style.scss"],"names":[],"mappings":"AACA,oEACE,WAAA,CACA,wBAAA,CACA,iBAAA,CACA,cAAA","sourcesContent":["@use 'src/utils/css/variables' as *;\n.container {\n  width: 182px;\n  border: solid 1px #747576;\n  border-radius: 3px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lHeaderHeight": "56px",
	"lCompanyHeight": "114px",
	"h2FontSize": "28px",
	"h3FontSize": "20px",
	"bodyLineHeight": "20px",
	"lGnShrinkWindowWidth": "1591px",
	"tableVerticalPadding": "8px",
	"tableHorizontalPadding": "16px",
	"lPersonnelBreakWidth": "1599px",
	"cNavigationAccent": "#f57f17",
	"cTableBodyOdd": "#fff",
	"cTableBodyEven": "#f2f6f8",
	"cTableHover": "#c5ddeb",
	"cTableHeadOdd": "#eaf1f5",
	"cTableHeadEven": "#dee8ef",
	"zPageLoading": "2",
	"container": "src-components-AiResearch-References-Graph-style__container--OBMga"
};
export default ___CSS_LOADER_EXPORT___;
